import React, { useState } from 'react';
import Styled from '../styles/AdminFVContainer.styled';
import StyledForm from '../styles/FormFV.styled';
import { MdClose } from 'react-icons/md';
import Colors from 'enums/Colors';
import ReactQuill from 'react-quill';
import { Input, InputNumber, Select } from 'antd';
import ImagemPreviewFerramentaVideo from './ImagemPreviewFerramentaVideo';
import * as Yup from 'yup';
import { IFormFVContent } from '../interfaces/components/IFormFVContent';
import { AccessbilityFeatureEnum } from '../helpers/AccessbilityFeatureEnum';

// Schema de validação Yup
const validationSchema = Yup.object().shape({
    title: Yup.string().required('Título é obrigatório').max(200, 'Máximo de 200 caracteres'),
    altFilePath: Yup.string().max(100, 'Máximo de 100 caracteres'),
    // outros campos se necessário
});

const FormFVContent = ({
    formVisible,
    handleSubmit,
    setForm,
    setFormVisible,
    form,
    handleChange,
    loading,
    roles,
    notAccessibility,
}: IFormFVContent) => {
    const [base64, setBase64] = useState<string | null>(null);

    // Add a handler that matches the expected signature for onResetBase64

    const handleResetBase64 = () => {
        setForm((prev: any) => ({ ...prev, capaBase64: null, filePathCapa: null }));
        setBase64(null);
    };

    // Estado para erros de validação
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    // Novo handler para submit que valida com Yup antes de submeter
    const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            await validationSchema.validate(form, { abortEarly: false });
            setErrors({});
            handleResetBase64();
            handleSubmit(e);
        } catch (err: any) {
            if (err.inner) {
                const formErrors: { [key: string]: string } = {};
                err.inner.forEach((validationError: any) => {
                    if (validationError.path && !formErrors[validationError.path]) {
                        formErrors[validationError.path] = validationError.message;
                    }
                });
                setErrors(formErrors);
            }
        }
    };

    return (
        <StyledForm.FormPackage onSubmit={handleFormSubmit} active={formVisible}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="title">Título</Styled.Label>
                    <Input
                        size="large"
                        name="title"
                        id="title"
                        value={form.title}
                        onChange={handleChange}
                        maxLength={200}
                        showCount
                        required
                        placeholder="Digite o título"
                    />
                    {errors.title && <div style={{ color: 'red', fontSize: 12 }}>{errors.title}</div>}
                </Styled.FormGroup>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="description">Descrição</Styled.Label>
                    <ReactQuill
                        value={form.description}
                        onChange={v => {
                            setForm((prev: any) => ({ ...prev, description: v }));
                        }}
                        placeholder="Digite a descrição"
                        style={{
                            backgroundColor: 'white',
                            color: 'black',
                        }}
                    />
                </Styled.FormGroup>
                <Styled.FormTwoGrid>
                    {!notAccessibility && (
                        <Styled.FormGroup>
                            <Styled.Label htmlFor="altUrl">Qual o tipo de acessibilidade do conteúdo?</Styled.Label>
                            <Select
                                mode="multiple"
                                size="large"
                                id="accessibilityFeatures"
                                value={form.accessibilityFeatures ?? (form.accessibilityFeature ? [form.accessibilityFeature] : [])}
                                onChange={value =>
                                    setForm((prev: any) => ({
                                        ...prev,
                                        accessibilityFeatures: value,
                                        accessibilityFeature: value[0] ?? undefined,
                                    }))
                                }
                                placeholder="Selecione uma ou mais opções"
                            >
                                <Select.Option value={AccessbilityFeatureEnum.LIBRAS}>Libras</Select.Option>
                                <Select.Option value={AccessbilityFeatureEnum.AUDIO}>Audio Descrição</Select.Option>
                            </Select>
                            {errors.accessibilityFeatures && <div style={{ color: 'red', fontSize: 12 }}>{errors.accessibilityFeatures}</div>}
                        </Styled.FormGroup>
                    )}
                    <Styled.FormGroup>
                        <Styled.Label htmlFor="roleIds">Conteúdo relacionado alguma regra de negócio?</Styled.Label>
                        <Select
                            mode="multiple"
                            size="large"
                            id="roleIds"
                            value={form.roleIds || []}
                            onChange={value =>
                                setForm((prev: any) => ({
                                    ...prev,
                                    roleIds: value,
                                    roleId: value && value.length === 1 ? value[0] : null,
                                }))
                            }
                            placeholder="Selecione uma ou mais regras"
                        >
                            {roles.map(role => (
                                <Select.Option key={role.id} value={role.id}>
                                    {role.name}
                                </Select.Option>
                            ))}
                        </Select>
                        {errors.roleIds && <div style={{ color: 'red', fontSize: 12 }}>{errors.roleIds}</div>}
                    </Styled.FormGroup>
                </Styled.FormTwoGrid>

                <Styled.FormGroup>
                    <Styled.Label htmlFor="description">Ordenação</Styled.Label>
                    <InputNumber min={1} max={10} value={form.ordem} onChange={value => setForm((prev: any) => ({ ...prev, ordem: value }))} />
                </Styled.FormGroup>
                {/* <Styled.FormGroup>
                    <Styled.Label htmlFor="pounds">Pacote com acessibilidade em Libras</Styled.Label>
                    <Switch
                        checked={form.inPounds ?? true}
                        onChange={checked => setForm((prev: any) => ({ ...prev, inPounds: checked }))}
                        style={{ width: 40 }}
                    />
                </Styled.FormGroup> */}
                <Styled.Button type="submit" disabled={loading}>
                    {' '}
                    {loading ? <div className="loaderConteudo" style={{ width: '26px' }} /> : form.codigo > 0 ? 'Atualizar' : 'Criar'} Conteúdo
                </Styled.Button>
            </div>
            <div style={{ position: 'relative' }}>
                <MdClose
                    style={{ cursor: 'pointer', position: 'absolute', top: -20, right: 0 }}
                    size={32}
                    color={Colors.Blue}
                    onClick={() => setFormVisible(false)}
                />
                <Styled.FormGroup>
                    <Styled.FormGroup>
                        <Styled.Label htmlFor="altFilePathCapa">Texto alternativo Imagem</Styled.Label>
                        <Input
                            size="large"
                            name="altFilePathCapa"
                            id="altFilePathCapa"
                            value={form.altFilePathCapa}
                            onChange={handleChange}
                            maxLength={100}
                            showCount
                            placeholder="Digite o texto alternativo da imagem"
                        />
                        {errors.altFilePathCapa && <div style={{ color: 'red', fontSize: 12 }}>{errors.altFilePathCapa}</div>}
                    </Styled.FormGroup>
                    <Styled.Label htmlFor="tags">Imagem da capa</Styled.Label>
                    <ImagemPreviewFerramentaVideo
                        filepath={form.filePathCapa}
                        resetForm={handleResetBase64}
                        onBase64Change={base64 => setForm((prev: any) => ({ ...prev, capaBase64: base64 }))}
                        base64={base64 ?? ''}
                        setBase64={setBase64}
                    />
                </Styled.FormGroup>
            </div>
        </StyledForm.FormPackage>
    );
};

export default FormFVContent;
